module.exports = __webpack_public_path__ + "img/Ic_remove_mylist.f6189883.svg";